import { SDLResolverSpec } from '../utils/SDLContent.utils';

export const resolveCameraInfoSpec: SDLResolverSpec = {
  model_name: ['basicInformation', 'ModelName'],
  manufacturer: ['basicInformation', 'ManufacturerName'],
  equivalent_models: ['basicInformation', 'EquivalentModels'],
  device_type: ['basicInformation', 'DeviceType'],
  audio: ['additionalInformation', 'Audio', 'AudioSupport'],
  i_o: ['io'],
  compression_types: ['maxStreams'],
  initial_release: ['initialRelease'],
  license_type: ['basicInformation', 'LicenseType'],
  license_count: ['basicInformation', 'LicenseCount'],
};

export const resolveAccessControlInfoSpec: SDLResolverSpec = {
  manufacturer_name: ['basicInformation', 'ManufacturerName'],
  model_name: ['basicInformation', 'ModelName'],
  device_type: ['basicInformation', 'DeviceType'],
  protocol: ['additionalInformation', 'Protocol'],
  connection_type: ['additionalInformation', 'ConnectionType'],
  integration_point: ['additionalInformation', 'IntegrationPoint'],
  initial_release: ['additionalInformation', 'InitialRelease'],
};

export const resolveIntercomInfoSpec: SDLResolverSpec = {
  model_name: ['basicInformation', 'ModelName'],
  manufacturer_name: ['basicInformation', 'ManufacturerName'],
  device_type: ['basicInformation', 'DeviceType'],
};

export const resolveStratocastInfoSpec: SDLResolverSpec = {
  model_name_link: ['stratocastModel'],
  manufacturer_name: ['basicInformation', 'ManufacturerName'],
  device_type: ['basicInformation', 'DeviceType'],
  notes: ['basicInformation', 'Comments'],
};

export const resolveSaasInfoSpec: SDLResolverSpec = {
  manufacturer: ['basicInformation', 'Manufacturer'],
  minimum_firmware: ['basicInformation', 'Minimum_firmware'],
  model: ['basicInformation', 'Model'],
  notes: ['basicInformation', 'Notes'],
  type: ['basicInformation', 'Type'],
  integration: ['basicInformation', 'integration'],
  support_since: ['basicInformation', 'support_since'],
};

export const resolveDefaultInfoSpec: SDLResolverSpec = {
  manufacturer_name: ['basicInformation', 'ManufacturerName'],
  model_name: ['basicInformation', 'ModelName'],
  device_type: ['basicInformation', 'DeviceType'],
};

export const deviceTypeResolveMap: Record<string, SDLResolverSpec> = {
  camera: resolveCameraInfoSpec,
  'access-control': resolveAccessControlInfoSpec,
  intercom: resolveIntercomInfoSpec,
  stratocast: resolveStratocastInfoSpec,
  saas: resolveSaasInfoSpec,
};
